const colors = {
  black: '#000000',
  white: '#ffffff',
  green: 'rgb(4, 136, 72)',
  yellow: 'rgb(255, 192, 67)',
  orange: 'rgb(237, 110, 51)',
  brown: 'rgb(153, 100, 76)',
  gray: 'rgb(175, 175, 175)',
  blue: 'rgb(93, 123, 159)',
  lightBlue: 'rgb(203, 220, 240)',
  lightYellow: 'rgb(255, 247, 234)',
  darkGray: 'rgb(84, 84, 84)',
  red: 'rgb(221, 44, 0)',
  lightRed: 'rgb(255, 214, 204)',
} as const;

export type ColorVariantType = keyof typeof colors;

export default colors;
